<app-header></app-header>
<div class="principal-container">
  
  <div class="second-container">
    <h1 class="principal-title">Información del evento</h1>
    <div class="opciones"></div>
  </div>

  <div class="main-info-container">
    <div class="general-info-container">
        <div class="field-cont">
            <h1>Nombre del evento</h1>
            <p>{{ nombre_event }}</p>
        </div>
        <div class="field-cont">
            <h1>Tipo de evento</h1>
            <p>{{ tipo_event}}</p>
        </div>
        <div class="field-cont">
            <h1>Fecha creación</h1>
            <p>{{ fecha_creacion}}</p>
        </div>
      </div>
    
      <div class="options-container">
        <button>Visitantes</button>
        <button>Opciones</button>
      </div>
      <div class="list-container">
        <div class="list-visitor-container">
          <div class="list-element" style="border-bottom: 2px solid gray;">
            <p>Nº</p>
            <p>Correo</p>
            <p>Fecha y hora de ingreso</p>
          </div>
          <div class="list-element" *ngFor="let user of list_users; index as i; ">
            <p>{{i+1}}</p>
            <p>{{user.correo_visitante}}</p>
            <p>{{user.fecha_registro_visitante.split(" ")[0]+" "+(user.fecha_registro_visitante.split(" ")[1]).split(".")[0]}}</p>
          </div>
        </div>
      </div>
  </div>

  
</div>
<app-footer></app-footer>